import accounting from 'accounting'
import numeral from 'numeral'
import getSymbolFromCurrency from 'currency-symbol-map'

export default {
  install (Vue) {
    Vue.filter('currency', (value, currency) => {
      if (value === '' || value === null || value === undefined) {
        return
      }
      if (currency === 'points') {
        return Number(value).toLocaleString() + ' Points'
      } else {
        if (getSymbolFromCurrency(currency) !== '$') {
          return accounting.formatMoney(value, getSymbolFromCurrency(currency))
        } else {
          return accounting.formatMoney(value, getSymbolFromCurrency(currency)) + ' ' + currency
        }
      }
    })

    Vue.filter('abbreviatedNumber', (value) => {
      return numeral(value).format('Oa').toUpperCase()
    })

    Vue.filter('abbreviatedCurrency', (value, currency) => {
      if (value === '' || value === null || value === undefined) {
        return
      }
      if (currency === 'points') {
        return Number(value).toLocaleString() + ' pt'
      } else {
        if (getSymbolFromCurrency(currency) !== '$') {
          return accounting.formatMoney(value, getSymbolFromCurrency(currency))
        } else {
          return accounting.formatMoney(value, getSymbolFromCurrency(currency)) + ' ' + currency
        }
      }
    })
  }
}
